import {
  TvShowKind,
  TvSlideTargetType,
  TvTagType,
  TvVideoFormat,
  TvVideoKind,
  TvVideoStatus,
} from "./types";

export const TV_LEAGUES: { value: number; label: string }[] = [
  { value: 100, label: "Лига PARI" },
  { value: 200, label: "LEON — Вторая Лига А" },
  { value: 300, label: "LEON — Вторая Лига Б" },
];

export const tvLeagueTitle = (leagueId?: number | null) =>
  TV_LEAGUES.find((l) => l.value === leagueId)?.label ?? "—";

export const TV_KIND_LABELS: Record<TvVideoKind, string> = {
  BROADCAST_RECORD: "Запись трансляции",
  REVIEW: "Обзор",
  HIGHLIGHT: "Хайлайт / момент",
  INTERVIEW: "Интервью",
  PRESS_CONFERENCE: "Пресс-конференция",
  SHOW_EPISODE: "Выпуск шоу",
  OTHER: "Другое",
};

export const TV_FORMAT_LABELS: Record<TvVideoFormat, string> = {
  HORIZONTAL: "Горизонтальное",
  VERTICAL: "Вертикальное",
};

export const TV_STATUS_LABELS: Record<TvVideoStatus, string> = {
  DRAFT: "Черновик",
  PUBLISHED: "Опубликовано",
  HIDDEN: "Скрыто",
};

export const TV_STATUS_COLORS: Record<TvVideoStatus, string> = {
  DRAFT: "default",
  PUBLISHED: "green",
  HIDDEN: "orange",
};

export const TV_TAG_LABELS: Record<TvTagType, string> = {
  LEAGUE: "Лига",
  TEAM: "Клуб",
  PLAYER: "Игрок",
  STAFF: "Сотрудник",
};

export const TV_SHOW_KIND_LABELS: Record<TvShowKind, string> = {
  ORIGINS: "Шоу «ФНЛ ТВ Originals»",
  SPECIAL: "Спецпроект",
};

export const TV_TARGET_LABELS: Record<TvSlideTargetType, string> = {
  VIDEO: "Видео",
  MATCH: "Матч",
  LEAGUE: "Страница лиги",
  SHOW: "Шоу / спецпроект",
  COLLECTION: "Подборка",
  URL: "Внешняя ссылка",
};

export const toOptions = <T extends string>(labels: Record<T, string>) =>
  (Object.keys(labels) as T[]).map((value) => ({
    value,
    label: labels[value],
  }));

/** Адрес страницы: латиница, цифры и дефис, как проверяет бэкенд. */
export const SLUG_PATTERN = /^[a-z0-9-]{2,128}$/;

export const formatDuration = (sec?: number | null) => {
  if (sec == null) return "";
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
};

/** «12:34» или «754» → секунды; пусто → null; мусор → NaN. */
export const parseDuration = (value?: string | null): number | null => {
  const text = (value ?? "").trim();
  if (!text) return null;
  if (/^\d+$/.test(text)) return Number(text);
  const m = text.match(/^(\d+):([0-5]\d)$/);
  return m ? Number(m[1]) * 60 + Number(m[2]) : NaN;
};
